module.exports = __webpack_public_path__ + "img/csr_swiper_01_07.a24c3aa1.jpg";